module.exports = __webpack_public_path__ + "media/app/images/podcast_cta@2x-6470e450601ed076dfd1f29e1b4f6ce6.png";